// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"febbb463","151":"a3a0ffe6","180":"0cd7085d","591":"91f5e69e","668":"7bc3ce4c","800":"774ec51c"}[chunkId] + ".chunk.js";
};